var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS, legalDepositsPeriodicalLibrariesId, legalDepositsPeriodicalLibrariesIdStatus, legalDepositsPeriodicalsTitlesId, legalDepositsPeriodicalsIdAcceptSkc, legalDepositsPeriodicalsIdKeepRecek, legalDepositsPeriodicalsIdKultSubjectGroup, } from "../types/apiPaths";
export var fetchPeriodicalLibraries = function (kyInstance, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        searchParams = new URLSearchParams();
        searchParams.append("status", params.status);
        searchParams.append("offset", String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
        searchParams.append("limit", String((_b = params.limit) !== null && _b !== void 0 ? _b : 100));
        if ((_c = params.name) === null || _c === void 0 ? void 0 : _c.trim()) {
            searchParams.append("name", params.name.trim());
        }
        if ((_d = params.issn) === null || _d === void 0 ? void 0 : _d.trim()) {
            searchParams.append("issn", params.issn.trim());
        }
        if ((_e = params.publisherId) === null || _e === void 0 ? void 0 : _e.trim()) {
            searchParams.append("publisherId", params.publisherId.trim());
        }
        (_f = params.frequencies) === null || _f === void 0 ? void 0 : _f.forEach(function (frequency) {
            searchParams.append("frequencies", frequency);
        });
        (_g = params.kultSubjectGroupOrigins) === null || _g === void 0 ? void 0 : _g.forEach(function (origin) {
            searchParams.append("kultSubjectGroupOrigins", origin);
        });
        (_h = params.depositStatuses) === null || _h === void 0 ? void 0 : _h.forEach(function (depositStatus) {
            searchParams.append("depositStatuses", depositStatus);
        });
        (_j = params.enforcementTypes) === null || _j === void 0 ? void 0 : _j.forEach(function (enforcementType) {
            searchParams.append("enforcementTypes", enforcementType);
        });
        if (params.provisional) {
            searchParams.append("provisional", "true");
        }
        if (params.agendaState) {
            searchParams.append("agendaState", params.agendaState);
        }
        if (params.lastReceivedYear !== undefined) {
            searchParams.append("lastReceivedYear", String(params.lastReceivedYear));
        }
        if (params.lastReceivedIncludeOlder) {
            searchParams.append("lastReceivedIncludeOlder", "true");
        }
        if (params.neverReceived) {
            searchParams.append("neverReceived", "true");
        }
        if (params.activeOnly !== undefined) {
            searchParams.append("activeOnly", String(params.activeOnly));
        }
        if (params.exactCount)
            searchParams.append("exactCount", "true");
        if (params.countOnly)
            searchParams.append("countOnly", "true");
        if (params.sortBy)
            searchParams.append("sortBy", params.sortBy);
        if (params.sortDir)
            searchParams.append("sortDir", params.sortDir);
        return [2 /*return*/, kyInstance
                .get(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_LIBRARIES, {
                searchParams: searchParams,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchPeriodicalLibraryById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get(legalDepositsPeriodicalLibrariesId(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchPeriodicalTitleById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get(legalDepositsPeriodicalsTitlesId(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchPeriodicalsForVerification = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var search, issn, investigationStatus, publisher, sortBy, sortDir, _a, offset, _b, limit, searchParams, response;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    search = params.search, issn = params.issn, investigationStatus = params.investigationStatus, publisher = params.publisher, sortBy = params.sortBy, sortDir = params.sortDir, _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 100 : _b;
                    searchParams = new URLSearchParams();
                    if (search)
                        searchParams.append("search", search);
                    if (issn)
                        searchParams.append("issn", issn);
                    if (investigationStatus)
                        searchParams.append("investigationStatus", investigationStatus);
                    if (publisher)
                        searchParams.append("publisher", publisher);
                    if (params.provisional)
                        searchParams.append("provisional", "true");
                    if (params.exactCount)
                        searchParams.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams.append("countOnly", "true");
                    if (sortBy)
                        searchParams.append("sortBy", sortBy);
                    if (sortDir)
                        searchParams.append("sortDir", sortDir);
                    searchParams.append("offset", offset.toString());
                    searchParams.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_PERIODICALS_PENDING_VERIFICATION, { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
export var changePeriodicalLibraryStatus = function (kyInstance, id, 
// reason is missing in the generated Api.ts type but accepted by the backend
payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .patch(legalDepositsPeriodicalLibrariesIdStatus(id), {
                json: payload,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var subscribePeriodicalsBulk = function (kyInstance, selection) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .patch(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_SUBSCRIBE_BY_IDS, {
                json: { selection: selection },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var excludePeriodicalsBulk = function (kyInstance, selection, reason, note) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .patch(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_EXCLUDE_BY_IDS, {
                json: { selection: selection, reason: reason, note: note },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var excludePeriodicalsByTitles = function (kyInstance, selection, reason, note) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .patch(API_PATHS.LEGAL_DEPOSITS_PERIODICAL_LIBRARIES_EXCLUDE_BY_TITLES, {
                json: { selection: selection, reason: reason, note: note },
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var fetchFrequencyConflicts = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var _a, offset, _b, limit, searchParams, response;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 100 : _b;
                    searchParams = new URLSearchParams();
                    if (params.search)
                        searchParams.append("search", params.search);
                    if (params.sortBy)
                        searchParams.append("sortBy", params.sortBy);
                    if (params.sortDir)
                        searchParams.append("sortDir", params.sortDir);
                    if (params.exactCount)
                        searchParams.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams.append("countOnly", "true");
                    searchParams.append("offset", offset.toString());
                    searchParams.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_PERIODICALS_FREQUENCY_CONFLICTS, { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
export var acceptSkc = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalsIdAcceptSkc(id), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var keepRecek = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsPeriodicalsIdKeepRecek(id), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var fetchPeriodicalKultSubjectGroup = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPeriodicalsIdKultSubjectGroup(titleId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Subject group fetch error: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error fetching periodical KULT subject group:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updatePeriodicalKultSubjectGroup = function (kyInstance, titleId, code) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, kyInstance
                .patch(legalDepositsPeriodicalsIdKultSubjectGroup(titleId), {
                headers: getHeaders(),
                json: { code: code },
            })
                .json()];
    });
}); };
